var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "13px",
    viewBox: "0 0 19 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "left-arrow") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u05E1\\u05DB\\u05D9\\u05E8\\u05D4-\\u05DB\\u05DC\\u05DC\\u05D9\\u05EA",
    transform: "translate(-741.000000, -205.000000)",
    fill: "#0091FF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15-Copy",
    transform: "translate(725.000000, 133.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "left-arrow",
    transform: "translate(16.000000, 72.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.19789806,0.195519624 C6.46575223,-0.0651732081 6.88744156,-0.0651732081 7.15529572,0.195519624 C7.41410076,0.447405266 7.41410076,0.866627524 7.15529572,1.11792602 L2.3007406,5.84269003 L18.3201089,5.84269003 C18.6935362,5.84269003 19,6.13156587 19,6.49500926 C19,6.85845264 18.6935362,7.15672282 18.3201089,7.15672282 L2.3007406,7.15672282 L7.15529572,11.8726796 C7.41410076,12.1333725 7.41410076,12.5531819 7.15529572,12.8044804 C6.88744156,13.0651732 6.46575223,13.0651732 6.19789806,12.8044804 L0.194103779,6.9612032 C-0.0647012597,6.70931756 -0.0647012597,6.2900953 0.194103779,6.0387968 L6.19789806,0.195519624 Z",
    id: "Path"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueArrow);
export default __webpack_public_path__ + "static/media/blueArrow.b9bf51609998d6ac7e403b4ee7c513d8.svg";
export { ForwardRef as ReactComponent };